export const POST_CLOSING_DUE_DATE_TOOLTIP =
  'The post-closing due date is derived from the closing date per the configured post-closing SLA.';
